import React from 'react';
import Divider from "@material-ui/core/Divider";

const TabViewPresvalView = (props) => {

    return (
        <React.Fragment>
            <div class="p-tabview-presval p-component p-tabview-presval-top" id="contentTab">
                <ul class="p-tabview-presval-nav p-reset">
                    {
                        props.modelOptions.map(function (elem) {
                            return (
                                <li className= {props.activeIndex === elem.index ?
                                    "p-tabview-presval-selected p-highlight" : "p-unselectable-text"}
                                    role="tab"
                                    aria-selected={props.activeIndex === elem.index ? "true" : "false"}
                                    aria-expanded={props.activeIndex === elem.index ? "true" : "false"}
                                    style={{width: props.tabWidth, }}
                                >
                                    <button onClick={()=>{props.manageIndex(elem)}}
                                       className="p-menuitem-link"
                                       role="presentation" style={{textAlign:'left'}}>
                                        <span className="p-tabview-presval-title">{elem.label}</span>
                                    </button>

                                </li>
                            );
                        })
                    }
                </ul>
            </div>
            <div><br/><Divider/></div>
        </React.Fragment>
    )
};
export default TabViewPresvalView;